// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2g6Oa","rightAdornment":"Header_rightAdornment__Tu4IZ"};